import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * Bronson PlayButton component.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-play-button.html
 *
 * @param {string} [className] - Additional class names for the main component element.
 * @param {string} [iconClassName] - Alternative icon to overwrite the default one.
 * @param {boolean} [iconViaCss] - Render the icon via CSS instead of markup.
 * @param {string} [label] - The button label.
 * @param {string} [testId] - The `[data-testid]` attribute on the component element.
 * @param {object} [otherProps] - Other props passed to the component element.
 * @returns {JSX.Element} - The PlayButton component.
 * @constructor
 */
export function PlayButton({ className, iconClassName, iconViaCss, label, testId, ...otherProps }) {
  const buttonClassNameList = classNames('c-play-button', className).trim()
  const iconClassNameList = classNames(
    'c-play-button__icon',
    {
      'c-icon': !iconViaCss,
      'c-icon--[semantic-play]': !iconViaCss,
    },
    iconClassName
  ).trim()

  return (
    <button className={buttonClassNameList} data-testid={testId} {...otherProps}>
      <i className={iconClassNameList} aria-hidden="true" role="img"></i>
      <span className="c-play-button__label">{label}</span>
    </button>
  )
}

PlayButton.propTypes = {
  className: PropTypes.string, // Bronson template: 'modifiers'.
  iconClassName: PropTypes.string, // Bronson template: 'icon-class'.
  iconViaCss: PropTypes.bool, // Bronson template: 'icon-via-css'.
  label: PropTypes.string, // Bronson template: 'label'.
  testId: PropTypes.string, // Added for `[data-testid]` attribute.
}
